interface Props {
  selectedDate: Date;
  onSelect: (date: Date) => void;
}

const DAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

function getWeekDays(fromDate: Date): Date[] {
  const d = new Date(fromDate);
  const day = d.getDay(); // 0=Sun
  const diff = day === 0 ? -6 : 1 - day; // Monday-anchored
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return Array.from({ length: 7 }, (_, i) => {
    const date = new Date(d);
    date.setDate(d.getDate() + i);
    return date;
  });
}

function isSameDay(a: Date, b: Date) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function WeekBar({ selectedDate, onSelect }: Props) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const days = getWeekDays(selectedDate);

  return (
    <div className="zd-daystrip" role="tablist" aria-label="Week">
      {days.map((date, i) => {
        const isSelected = isSameDay(date, selectedDate);
        const isToday = isSameDay(date, today);
        return (
          <button
            key={date.toISOString()}
            onClick={() => onSelect(date)}
            className={isSelected ? "zd-day selected" : "zd-day"}
            role="tab"
            aria-selected={isSelected}
          >
            <div className="zd-day-dow">{DAY_LABELS[i]}</div>
            <div className="zd-day-num">{date.getDate()}</div>
            {isToday && <div className="zd-day-todaybar" />}
          </button>
        );
      })}
    </div>
  );
}
